import SimpleAssessmentController from './simple_assessment_controller'

export default class extends SimpleAssessmentController {

  static targets = [
    ...super.targets
  ]

  // ==== Controllers

  // ==== Actions

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
